module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$store.state.rotator.activeUrl) ? _c('Editor', {
    key: _vm.$store.state.rotator.activeUrl,
    attrs: {
      "window": _vm.editorWindow
    }
  }) : _vm._e(), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: (!_vm.$store.state.rotator.livePreview && _vm.activeIframe == 0),
      expression: "!$store.state.rotator.livePreview && activeIframe == 0"
    }],
    ref: "iframe-0",
    staticClass: "proxy-iframe",
    attrs: {
      "id": "iframe-0"
    }
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: (_vm.$store.state.rotator.livePreview && _vm.activeIframe == 0),
      expression: "$store.state.rotator.livePreview && activeIframe == 0"
    }],
    ref: "preview-0",
    staticClass: "proxy-iframe move-left",
    attrs: {
      "id": "preview-0"
    }
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: (!_vm.$store.state.rotator.livePreview && _vm.activeIframe == 1),
      expression: "!$store.state.rotator.livePreview && activeIframe == 1"
    }],
    ref: "iframe-1",
    staticClass: "proxy-iframe move-left",
    attrs: {
      "id": "iframe-1"
    }
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "visible",
      rawName: "v-visible",
      value: (_vm.$store.state.rotator.livePreview && _vm.activeIframe == 1),
      expression: "$store.state.rotator.livePreview && activeIframe == 1"
    }],
    ref: "preview-1",
    staticClass: "proxy-iframe move-left",
    attrs: {
      "id": "preview-1"
    }
  }), _vm._v(" "), _c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "sdk",
    staticClass: "proxy-iframe",
    attrs: {
      "id": "sdk"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aaf200d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radius/ProxyFrame.vue
// module id = ij/9
// module chunks = 1